module.exports = "/static/assets/fa4d69d8edddf8ec00b0cf01c7ab0261.gif";